import { render } from "./resources.vue?vue&type=template&id=3bd666be&scoped=true"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"

import "./resources.vue?vue&type=style&index=0&id=3bd666be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd666be"]])

export default __exports__